import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import type { CoinType } from '../../../stores/cointype/CoinTypeStore';
import { formatValueWithK } from '../../../utils/helpers';
import { formatTime } from '../../../utils/time';
import { I18Text } from '../../i18Next/I18Text';
import { SocialCoin } from '../../SocialCoin/SocialCoin';
import { SweepCoin } from '../../SweepCoin/SweepCoin';

import { CircleIcon } from './CircleIcon';
import styles from './freeSpinsIconNew.module.scss';
import { OutlineText } from './OutlineText';

type Props = {
  gameImage: string;
  betAmount: number;
  spinsCount: number;
  betCoinType: CoinType;
  type: 'freeSpins' | 'countdown';
  countdownSeconds: number;
};
export const FreeSpinsIconNew = ({ gameImage, spinsCount, betCoinType, betAmount, type, countdownSeconds }: Props) => {
  const { t } = useTranslation();
  const CoinIcon = betCoinType === 'GC' ? SocialCoin : SweepCoin;
  return (
    <div className={classNames(styles.wrapper, 'frb-widget-new')}>
      <div className={styles.iconContainer}>
        <CircleIcon className={styles.circle} />
        <div className={classNames(styles.gameImageContainer, 'frb-widget-new-game-image-container')}>
          <img alt="game image" className={styles.gameImage} src={gameImage} />
        </div>
      </div>
      <div className={styles.freeSpinsType}>
        {type === 'freeSpins' && (
          <div className={styles.spinsCount}>
            <OutlineText text={`${spinsCount}`} />
          </div>
        )}
        <div className={styles.text}>
          <I18Text i18nKey="frb.freeSpins" />
        </div>

        {type === 'freeSpins' && (
          <div className={styles.betAmount}>
            <CoinIcon className={styles.coin} />
            <span className={styles.value}>{formatValueWithK(Number(betAmount), t)}</span>
          </div>
        )}
        {type === 'countdown' && (
          <div className={styles.countdown}>
            <p>{formatTime(countdownSeconds, 's', t)}</p>
          </div>
        )}
      </div>
    </div>
  );
};
